import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Calendar } from '../../lib/icons';

interface SuccessStepProps {
  referralClaimFailed?: boolean;
}

export const SuccessStep: React.FC<SuccessStepProps> = ({ referralClaimFailed }) => {
  const navigate = useNavigate();

  return (
    <View style={styles.successContainer}>
      <View style={styles.successIcon}>
        <CheckCircle2 size={32} color="#16a34a" />
      </View>
      <View style={styles.successTextContainer}>
        <Text style={styles.successTitle}>Welcome to HoneyDone!</Text>
        <Text style={styles.successText}>
          Your account has been created successfully. Schedule your walkthrough to get started!
        </Text>
      </View>
      {referralClaimFailed && (
        <View style={styles.referralFailedBanner}>
          <Text style={styles.referralFailedTitle}>
            We couldn't apply your referral credit automatically.
          </Text>
          <Text style={styles.referralFailedText}>
            Don't worry — your signup is complete. Please contact{' '}
            <Text style={styles.referralFailedEmail}>support@honeydone.com</Text> and we'll
            apply the credit to your account.
          </Text>
        </View>
      )}
      <View style={styles.buttonContainer}>
        <Pressable
          onPress={() => navigate('/schedule-walkthrough')}
          style={styles.primaryButton}
        >
          <Calendar size={16} color="#ffffff" />
          <Text style={styles.primaryButtonText}>Schedule Walkthrough</Text>
          <ArrowRight size={16} color="#ffffff" />
        </Pressable>
        <Pressable onPress={() => navigate('/dashboard')} style={styles.secondaryLinkWrapper}>
          <Text style={styles.secondaryButtonText}>Skip for now</Text>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  successContainer: {
    alignItems: 'center',
    gap: 24,
  },
  successIcon: {
    width: 64,
    height: 64,
    backgroundColor: '#f0fdf4',
    borderRadius: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  successTextContainer: {
    gap: 8,
    alignItems: 'center',
  },
  successTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#111827',
  },
  successText: {
    fontSize: 16,
    color: '#4b5563',
    textAlign: 'center',
  },
  buttonContainer: {
    width: '100%',
    gap: 12,
    alignItems: 'center',
  },
  primaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: '#000000',
    borderRadius: 8,
    width: '100%',
  },
  primaryButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '500',
  },
  secondaryLinkWrapper: {
    textDecorationLine: 'none',
  },
  secondaryButtonText: {
    color: '#6b7280',
    fontSize: 14,
    fontWeight: '500',
    textDecorationLine: 'underline',
  },
  referralFailedBanner: {
    width: '100%',
    backgroundColor: '#fef3c7',
    borderRadius: 12,
    padding: 16,
    borderWidth: 1,
    borderColor: '#fde68a',
  },
  referralFailedTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#92400e',
    marginBottom: 4,
  },
  referralFailedText: {
    fontSize: 13,
    color: '#78350f',
    lineHeight: 18,
  },
  referralFailedEmail: {
    fontWeight: '600',
  },
});
